import React from 'react';
import autoBind from 'react-autobind';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import HelpToolTip from '../../components/HelpToolTip';

class FieldSelect extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange(event, index, value) {
    this.props.onChange({ name: this.props.name, value: value });
  }

  render() {
    const _props = { ...this.props };
    _props.onChange = this.handleChange;
    const options = [..._props.options];
    delete _props.options;
    return (
      <div style={{ position: 'relative' }}>
        <SelectField
          floatingLabelStyle={this.props.tooltip ? { paddingLeft: 32 } : {}}
          fullWidth
          floatingLabelFixed
          floatingLabelText={_props.label}
          {..._props}
        >
          {options.map((option, index) => (
            <MenuItem
              key={index}
              value={option.value}
              primaryText={option.text}
              secondaryText={
                option.secondaryText && (
                  <div style={style.secondaryText}>{option.secondaryText}</div>
                )
              }
              leftIcon={option.image && <img src={option.image} alt="" />}
            />
          ))}
        </SelectField>
        {this.props.tooltip && (
          <HelpToolTip
            style={{ position: 'absolute', top: 12, left: 0 }}
            tip={this.props.tooltip}
          />
        )}
      </div>
    );
  }
}

export default FieldSelect;

const style = {
  secondaryText: {
    float: 'right',
    color: 'rgba(0, 0, 0, 0.3)',
    fontSize: '75%'
  }
};



// WEBPACK FOOTER //
// ./src/components/FieldSelect/index.jsx